/* import __COLOCATED_TEMPLATE__ from './sdr-followup-email.hbs'; */
/* RESPONSIBLE TEAM: team-ml */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type AiAgentSetupService from 'embercom/services/ai-agent-setup-service';
import type SdrFollowupEmail from 'embercom/models/operator/visual-builder/step/sdr-followup-email';
import type EditorState from 'embercom/objects/workflows/graph-editor/editor-state';
import { type ComponentLike } from '@glint/template';
import type ConnectionPoint from 'embercom/models/operator/visual-builder/connection-point';

interface Signature {
  Args: {
    step: SdrFollowupEmail;
    stepConfig?: Record<string, unknown>;
    editorState: EditorState;
    updateConnectionPoints: () => void;
    connectionPointComponent: ComponentLike<{ connectionPoint: ConnectionPoint }>;
    readOnly: boolean;
  };
}

export default class SdrFollowupEmailComponent extends Component<Signature> {
  @service declare aiAgentSetupService: AiAgentSetupService;

  get hasInvalidEmailSetup() {
    return !this.aiAgentSetupService.validateEmailSetup.isValid;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Workflows::GraphEditor::NodeItems::Steps::SdrFollowupEmail': typeof SdrFollowupEmailComponent;
  }
}
